import React from 'react'

import cx from 'classnames'

import { Icon } from '@driftt/tide-icons'

import styles from './styles.module.css'

export type EngagementScoreIndicatorVariant = 'neutral' | 'positive' | 'negative'

export const scoreToIndicator = (
  score: number,
  prevScore: number
): EngagementScoreIndicatorVariant => {
  if (score < prevScore) return 'negative'
  if (score > prevScore) return 'positive'
  return 'neutral'
}

interface EngagementScoreIndicatorProps {
  variant: EngagementScoreIndicatorVariant
  style?: React.CSSProperties
}

const EngagementScoreIndicator = ({ variant, style }: EngagementScoreIndicatorProps) => (
  <div style={style} className={styles.container}>
    {variant === 'neutral' && <Icon name="minus" width={10} height={10} />}
    {variant === 'positive' && (
      <Icon
        className={cx(styles.greenTextStyle, styles.rotateTransform)}
        name="arrow-2-right"
        height={10}
        width={10}
      />
    )}
    {variant === 'negative' && (
      <Icon
        className={cx(styles.redTextStyle, styles.rotateTransform)}
        name="arrow-2-left"
        height={10}
        width={10}
      />
    )}
  </div>
)

export default EngagementScoreIndicator
